<template lang="pug">
	div
		buscador
</template>

<script>
import Buscador from './components/buscador/index'
export default {
	components: {
		buscador: Buscador
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/invitaciones/vue/main.vue